import { format, parse } from "date-fns";
import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import OrderDetailItems from "../../../Common/Components/OrderDetailItems";
import { TitleHeader } from "../../../Common/Components/TitleHeader";
import { transformOrderDetailItems } from "../../../Services/MainService";
import { fetchOrderDetails } from "../../Services/OrderService";

export const OrderView = () => {
  const [loading, setLoading] = React.useState(false);
  const params = useParams();
  const [details, setDetails] = React.useState(null);
  const [items, setItems] = React.useState([]);
  const [tax, setTax] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [subtotal, setSubtotal] = React.useState(0);
  const [itemPrice, setItemPrice] = React.useState(0);
  const [voucher, setVoucher] = React.useState("");
  const [discount, setDiscount] = React.useState(0);
  const [delivery, setDelivery] = React.useState(0);
  //   const [deliveryType, setDeliveryType] = React.useState(null);
  // const [trackOrder, setTrackOrder] = React.useState(null);
  //   const [cLoading, setCLoading] = React.useState(false);
  const config = useSelector((x) => x.Config);
  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [track, setTrack] = React.useState([]);
  const [trackLoading] = React.useState(false);
  //   const [cShow, setCShow] = React.useState(false);
  const location = useLocation();
  const [open, setOpen] = React.useState({});
  const [count, setCount] = React.useState(0);
  const [address, setAddress] = React.useState(null);
  const [referralDiscount, setReferralDiscount] = React.useState(0);

  // React.useEffect(() => {
  //   setLoading(true);
  //   fetchDeliveryType(50, 1).then(
  //     (res) => {
  //       setLoading(false);
  //       setDeliveryType(
  //         res.find((x) => x.title?.trim()?.toLowerCase() === orderType)
  //       );
  //     },
  //     (er) => {
  //       console.warn(er, "delivery types failed");
  //     }
  //   );
  // }, []);

  React.useEffect(() => {
    console.clear();
    const orderId = params?.["id"];
    if (!orderId) {
      navigate(-1, { replace: true });
    } else {
      setLoading(true);
      fetchOrderDetails(orderId).then(
        (res) => {
          setLoading(false);
          const { count, open, record, items_price } =
            transformOrderDetailItems(res.data.details);
          setCount(count);
          setOpen(open);
          setItems(record);
          setItemPrice(items_price);
          setTotal(res.data.order_amount);
          setSubtotal(res.data.subtotal);
          setVoucher(res.data.coupon_code);
          setTax(res.data.tax_amount);
          setDiscount(res.data.discount_amount);
          setReferralDiscount(res.data.referral_discount_amount);
          setDelivery(res.data.delivery_charge);
          //   setDeliveryType(res.data.laundry_delivery_type);
          setDetails(res.data);

          setAddress({
            pickup_coordinates: {
              longitude: res.data.pickup_coordinates?.coordinates?.[0],
              latitude: res.data.pickup_coordinates?.coordinates?.[1],
            },
            destination_coordinates: {
              longitude: res.data.destination_coordinates?.coordinates?.[0],
              latitude: res.data.destination_coordinates?.coordinates?.[1],
            },
            pickup_address: {
              ...res.data.pickup_address,
            },
            destination_address: {
              ...res.data.destination_address,
            },
          });
          processTrack(res.data);
        },
        (er) => {
          console.warn(er, "error on order fetch");
        }
      );
    }
  }, [params, location]);

  //   const cOrder = () => {
  //     if (!cLoading) {
  //       setCLoading(true);
  //       cancelOrder(details.id).then(
  //         (res) => {
  //           toast.success("Order cancelled Successfully!");
  //           navigate(`/app/order-canceled?orderId=${details.id}`, {
  //             replace: true,
  //           });
  //         },
  //         (er) => {
  //           setCLoading(false);
  //           toast.error("Something went wrong while canceling order!");
  //         }
  //       );
  //     }
  //   };
  const convertDate = (dateString) => {
    // Parse the date string into a Date object
    const date = parse(dateString, "yyyy-MM-dd HH:mm:ss", new Date());
    // Convert the Date object to an ISO string
    return date;
  };
  const transformStatus = (date, status) => {
    if (date) {
      const t = convertDate(date);
      return {
        status,
        time: format(t, "p"),
        date: format(t, "p, eee, dd MMM yyyy"),
      };
    }
  };
  const processTrack = (d) => {
    if (d) {
      const temp = [];
      const pending = transformStatus(d.pending, "Pending");
      if (pending) temp.push(pending);
      const confirmed = transformStatus(d.confirmed, "Confirmed");
      if (confirmed) temp.push(confirmed);
      const out_for_pickup = transformStatus(
        d.out_for_pickup,
        "Out For Pickup"
      );
      if (out_for_pickup) temp.push(out_for_pickup);
      const picked_up = transformStatus(d.picked_up, "Picked Up");
      if (picked_up) temp.push(picked_up);
      const arrived = transformStatus(d.arrived, "Arrived");
      if (arrived) temp.push(arrived);
      const processing = transformStatus(d.processing, "Processing");
      if (processing) temp.push(processing);
      const ready_for_delivery = transformStatus(
        d.ready_for_delivery,
        "Ready For Delivery"
      );
      if (ready_for_delivery) temp.push(ready_for_delivery);
      const out_for_delivery = transformStatus(
        d.out_for_delivery,
        "Out For Delivery"
      );
      if (out_for_delivery) temp.push(out_for_delivery);
      const delivered = transformStatus(d.delivered, "Delivered");
      if (delivered) temp.push(delivered);
      const deferred_at = transformStatus(d.deferred_at, "Deferred");
      if (deferred_at) temp.push(deferred_at);
      const cancelled = transformStatus(d.cancelled, "Cancelled");
      if (cancelled) temp.push(cancelled);
      const failed = transformStatus(d.failed, "Failed");
      if (failed) temp.push(failed);
      setTrack(temp);
    }
  };
  return (
    <>
      <TitleHeader
        title={"Order Details"}
        // subtitle={"Below are the order details."}
      />
      <div className="container" style={{ minHeight: "80vh" }}>
        <div className="row justify-content-center py-4">
          <div className="col-xl-6 col-lg-7 col-md-10 col-12">
            {loading ? (
              <div className="text-center">
                <Spinner variant="primary" />
              </div>
            ) : details ? (
              <>
                <div className="card mb-3">
                  <div className="card-body">
                    <h5 className="fw-bold mb-1">{details?.id}</h5>
                    <h5 className="fw-normal" style={{ color: "#828282" }}>
                      {/* {format(details?.creation_date, "p, eee, dd MMM yyyy")} */}
                    </h5>
                    <hr style={{ borderStyle: "dashed", margin: "10px 0px" }} />
                    <div className="d-flex align-items-center">
                      <div className="col-7">
                        <h6 className="fw-bold mb-1">Order Type</h6>
                        <h6 className="fw-normal" style={{ color: "#828282" }}>
                          {details?.delivery_type?.id == "3"
                            ? "Come & Collect "
                            : details.delivery_type?.title}{" "}
                          {details?.delivery_type?.id == "3"
                            ? `(${
                                details?.booking_type == "1"
                                  ? "Regular"
                                  : "Express"
                              })`
                            : null}
                        </h6>
                      </div>
                      <div className="col-5">
                        <h6 className="fw-bold mb-1">Payment Method</h6>
                        <small
                          className={`history-order-card-delivery-type-badge ${
                            details?.payment_method === "card_on_delivery"
                              ? "blue"
                              : ""
                          }`}
                        >
                          {details?.payment_method === "cash_on_delivery"
                            ? "cod"
                            : details?.payment_method === "card_on_delivery"
                            ? "ccod"
                            : "Digital"}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Service based Item cards Card */}
                <OrderDetailItems items={items} setOpen={setOpen} open={open} />
                {/* Total/Subtotal */}
                <div className="card mb-3">
                  <div
                    className="card-header border-0"
                    style={{ backgroundColor: "#fff" }}
                  >
                    <Table borderless responsive className="mb-0">
                      <tbody>
                        <tr>
                          <td className="fw-semibold">Total Items</td>
                          <td className="fw-bold text-end">
                            {count?.toLocaleString()} item(s)
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-semibold">Item Price</td>
                          <td className="fw-bold text-end">
                            Rs. {itemPrice?.toLocaleString()}
                          </td>
                        </tr>
                        {/* <tr>
                          <td className="fw-semibold">
                            Total Price (Incl. Tax)
                          </td>
                          <td className="fw-bold text-end">
                            Rs. {itemPrice?.toLocaleString()}
                          </td>
                        </tr> */}
                      </tbody>
                    </Table>
                  </div>
                  <hr className="mt-0" />
                  <div className="card-body pt-0">
                    <Table borderless responsive className="mb-0">
                      <tbody>
                        {/* <tr>
                          <td className="fw-semibold">
                            Total Price (Excl. Tax)
                          </td>
                          <td className="fw-bold text-end">
                            Rs. {itemPriceNoTax?.toLocaleString()}
                          </td>
                        </tr> */}
                        {referralDiscount > 0 && (
                          <tr style={{ backgroundColor: "#d0f0c0" }}>
                            <td className="fw-semibold">Referral Discount</td>
                            <td className="fw-bold text-end"> Rs. {Math.round(referralDiscount)?.toLocaleString()}</td>
                          </tr>
                        )}
                        {discount ? (
                          <>
                            <tr>
                              <td
                                className="fw-semibold"
                                style={{ backgroundColor: "#94e19459" }}
                              >
                                Discount
                              </td>
                              <td
                                className="fw-bold text-end"
                                style={{ backgroundColor: "#94e19459" }}
                              >
                                -Rs. {discount?.toLocaleString()}
                              </td>
                            </tr>
                            <tr>
                              <td className="fw-semibold">Voucher Used</td>
                              <td className="fw-bold text-end">{voucher}</td>
                            </tr>
                          </>
                        ) : null}
                        <tr>
                          <td className="fw-semibold">Subtotal</td>
                          <td className="fw-bold text-end">
                            Rs. {subtotal?.toLocaleString()}
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-semibold">VAT / Tax</td>
                          <td className="fw-bold text-end">
                            Rs. {tax.toLocaleString()}
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-semibold">Delivery Fee</td>
                          <td className="fw-bold text-end">
                            Rs. {parseFloat(delivery)?.toLocaleString()}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <hr className="my-0" />
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-semibold">Total</td>
                          <td className="fw-bold text-end">
                            Rs. {total?.toLocaleString()}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
                {/* Dates */}
                <div className="card mb-3">
                  <div className="card-body">
                    <h5 className="fw-bold">Scheduled Dates</h5>
                    <div className="app-dates-container border border-gray rounded mt-4">
                      <div className="col-12 col-md-5 px-4">
                        <small
                          style={{ position: "absolute", top: "-12px" }}
                          className="bg-white px-2"
                        >
                          Pickup
                        </small>
                        <div className="d-flex align-items-center py-3 border-r border-gray">
                          <i
                            className="fa-regular fa-calendar-plus me-3"
                            style={{ fontSize: "22px", color: "#666" }}
                          ></i>
                          {format(
                            parse(
                              details?.order_pickup_time_slot_date,
                              "yyyy-MM-dd",
                              Date.now()
                            ),
                            "iii, dd MMM"
                          )}
                          <br />
                          {details?.order_pickup_time_slot}
                        </div>
                      </div>
                      <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                        &nbsp;
                      </div>
                      <hr className="w-100 my-1 d-block d-md-none" />
                      <div className="col-12 col-md-5 px-4">
                        <small
                          style={{ position: "absolute" }}
                          className="bg-white px-2 app-dates-delivery-label"
                        >
                          Delivery
                        </small>
                        <div className="d-flex align-items-center py-3">
                          <i
                            className="fa-regular fa-calendar-plus me-3"
                            style={{ fontSize: "22px", color: "#666" }}
                          ></i>
                          {format(
                            parse(
                              details?.order_delivery_time_slot_date,
                              "yyyy-MM-dd",
                              Date.now()
                            ),
                            "iii, dd MMM"
                          )}
                          <br />
                          {details?.order_delivery_time_slot}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Addresses */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">Address</span>
                    <div className="row">
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-circle-dot"
                          style={{ color: "#32b6e9" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Pickup Address</h6>
                        <p className="m-0">
                          {address?.pickup_address
                            ? `${address?.pickup_address?.addressLine1}, ${address?.pickup_address?.addressLine2}, ${address?.pickup_address?.area}, ${address?.pickup_address?.area_phase}`
                            : "Select address"}
                        </p>
                        <hr style={{ borderStyle: "doted" }} />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-location-dot text-primary"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Delivery Address</h6>
                        <p className="m-0">
                          {address?.destination_address
                            ? `${address?.destination_address?.addressLine1}, ${address?.destination_address?.addressLine2}, ${address?.destination_address?.area}, ${address?.destination_address?.area_phase}`
                            : "Select address"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Note */}
                {/* {details.note ? (
                  <div className="card mb-3">
                    <div className="card-body">
                      <h5 className="fw-bold mb-3">Order Note.</h5>
                      <p>{details.note}</p>
                    </div>
                  </div>
                ) : null} */}
                  {details.note ? (() => {
                    const notes = JSON.parse(details.note);
                    return (
                      <div className="card mb-3">
                        <div className="card-body">
                          <h5 className="fw-bold mb-3">Order Note.</h5>
                          {notes.map((item, i) => (
                            <p key={i}>{item.note}</p>
                          ))}
                        </div>
                      </div>
                    );
                  })() : null}
                {/* Rider */}
                {details?.rider ? (
                  <div className="card mb-3">
                    <div className="card-body">
                      <h5 className="fw-bold mb-3">Rider Details</h5>
                      <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <div className="d-flex align-items-center flex-wrap">
                          <img
                            style={{ backgroundColor: "#eee" }}
                            src={`${config?.base_urls?.delivery_man_image_url}/${details?.rider.image}`}
                            alt=""
                            className="avatar p-1 me-2"
                          />
                          <h6 className="mb-0">{`${details.rider.f_name} ${details.rider.l_name}`}</h6>
                        </div>
                        <a href={`tel:${details.rider.phone}`}>
                          <i className="fa-solid fa-phone d-block"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
      </div>
      {details ? (
        <>
          <div className="container-fluid bg-white">
            <div
              className="row justify-content-center"
              style={{ padding: "20px 0px" }}
            >
              <div
                className="d-flex col-lg-6 col-md-7 col-12 justify-content-center flex-column flex-md-row"
                style={{ gap: "20px" }}
              >
                <div
                  className="text-center service-btn next"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  Track Order
                </div>

                {/* {details?.order_status === "pending" ? (
                  <div
                    className="text-center service-btn danger"
                    onClick={() => {
                      if (!cLoading) {
                        setCShow(true);
                      }
                    }}
                  >
                    {cLoading ? <Spinner size="sm" /> : null} Cancel Order
                  </div>
                ) : null} */}
              </div>
            </div>
          </div>
          <Modal
            show={show}
            centered
            onHide={() => {
              setShow(false);
            }}
            style={{ zIndex: 1056 }}
          >
            <Modal.Header closeButton className="py-2">
              <Modal.Title style={{ fontSize: "18px" }}>
                Order Status
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex flex-column align-items-center">
              {trackLoading ? (
                <div className="text-center">
                  <Spinner variant="primary" />
                </div>
              ) : track.length > 0 ? (
                <>
                  <div className="pe-4 w-100">
                    <ul className="app-timeline w-100">
                      {track.map((x, i) => (
                        <>
                          <li>
                            <div className="d-flex flex-wrap justify-content-between">
                              <span className="fw-semibold">{x.status}</span>
                              <span>{x.time}</span>
                            </div>
                            <span className="d-block mt-1">{x.date}</span>
                            {i !== track.length - 1 ? <hr /> : null}
                          </li>
                        </>
                      ))}
                    </ul>
                  </div>
                </>
              ) : (
                <h4 className="text-center text-uppercase text-muted">
                  No Records Found!
                </h4>
              )}
            </Modal.Body>
          </Modal>
        </>
      ) : null}
      {/* <ConfirmationModal
        show={cShow}
        text="Are you sure you want to cancel this order? "
        onNo={() => {
          setCShow(false);
        }}
        onYes={() => {
          setCShow(false);
          cOrder();
        }}
      /> */}
    </>
  );
};
